"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const uswds_react_utils_1 = require("@boozallen-uip/uswds-react-utils");
const GridRow = (0, react_1.forwardRef)(({ children, className, gaps, gapSize = 4, ...props }, ref) => {
    const gapClass = gaps ? `grid-gap-${gapSize}` : '';
    return ((0, jsx_runtime_1.jsx)("div", { ref: ref, className: (0, uswds_react_utils_1.createClassString)('grid-row', gapClass, className), ...props, children: children }));
});
exports.default = GridRow;
